import { Offering } from 'types/Portfolio/StructuredOffering'
import { addSeconds } from 'date-fns'

export function getEstimatedEndDate({ startDeadline, duration }: Offering) {
  return addSeconds(startDeadline, duration)
}
